import React from 'react'
import { FilterComponentProps } from '../../../../Types/TableType'
import { Col, Input, Label, Row } from 'reactstrap'

export default function FilterComponent({ onFilter, filterText }: FilterComponentProps) {
    return (
        <Row className="align-items-center justify-content-end">
            <Col xs="auto"><Label>{'Search'}:</Label></Col>
            <Col xs="auto" className='d-flex flex-row'>
                <Input type="text" value={filterText} onChange={onFilter} placeholder="Search..." />
            </Col>
        </Row>
    )
}
